/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
export var IdxStatus;
(function (IdxStatus) {
    IdxStatus["SUCCESS"] = "SUCCESS";
    IdxStatus["PENDING"] = "PENDING";
    IdxStatus["FAILURE"] = "FAILURE";
    IdxStatus["TERMINAL"] = "TERMINAL";
    IdxStatus["CANCELED"] = "CANCELED";
})(IdxStatus || (IdxStatus = {}));
export var AuthenticatorKey;
(function (AuthenticatorKey) {
    AuthenticatorKey["OKTA_PASSWORD"] = "okta_password";
    AuthenticatorKey["OKTA_EMAIL"] = "okta_email";
    AuthenticatorKey["OKTA_VERIFIER"] = "okta_verifier";
    AuthenticatorKey["PHONE_NUMBER"] = "phone_number";
    AuthenticatorKey["GOOGLE_AUTHENTICATOR"] = "google_otp";
})(AuthenticatorKey || (AuthenticatorKey = {}));
export var IdxFeature;
(function (IdxFeature) {
    IdxFeature[IdxFeature["PASSWORD_RECOVERY"] = 0] = "PASSWORD_RECOVERY";
    IdxFeature[IdxFeature["REGISTRATION"] = 1] = "REGISTRATION";
    IdxFeature[IdxFeature["SOCIAL_IDP"] = 2] = "SOCIAL_IDP";
})(IdxFeature || (IdxFeature = {}));
